import { Component, Input, forwardRef, OnChanges, SimpleChanges, Inject, OnInit, OnDestroy } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';

import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { BriefingImageEffectsModel } from '../../../models/briefing-image-effects.model';
import { ImageEffectsFieldModel } from '../../../models/image-effects-field.model';
import { BriefingImageFrameEnum } from '../../../../../Monitor/Shared/enums/briefing-image-frame.enum';
import { AbstractPageBuilderService } from '../../../services/abstract-page-builder.service';
import { BriefingImageDisplayElementModel } from '@Common/PageBuilder/models/briefing-image-display-element.model';
import { AdvancedColorPickerFieldModel, textColorConfig } from '@Common/PageBuilder/models/advanced-color-picker-field.model';

@Component({
    selector: 'agpr-image-effects-field',
    templateUrl: './image-effects-field.component.html',
    styleUrls: ['./image-effects-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => ImageEffectsFieldComponent)
        }
    ],
    standalone: false
})
export class ImageEffectsFieldComponent extends AbstractFormFieldComponent implements OnChanges, OnInit, OnDestroy {
    readonly briefingImageFrame = BriefingImageFrameEnum;

    @Input() override field: ImageEffectsFieldModel;
    @Input() override value: BriefingImageEffectsModel;

    primColorPickerField: AdvancedColorPickerFieldModel;
    // backColorPickerField: ColorPickerFieldModel;

    imageDisplayElement: BriefingImageDisplayElementModel;

    imageFrames: {
        key: BriefingImageFrameEnum;
        img: string;
        label: string;
    }[] = [
        {
            key: this.briefingImageFrame.NO_FRAME,
            img: null,
            label: `Briefings.fields.image.${this.briefingImageFrame.NO_FRAME}`
        },
        {
            key: this.briefingImageFrame.COLLAGE,
            img: 'assets/images/online_briefing_frame_style_image_grid.svg',
            label: `Briefings.fields.image.${this.briefingImageFrame.COLLAGE}`
        }
    ];

    defaultBriefingColor: string;
    enableTransition: boolean = false;

    subscriptions: Subscription[] = [];

    constructor(
        public messageService: MessageService,
        public localizationService: LocalizationService,
        public coreDialogService: CoreDialogService,
        public pageBuilderService: AbstractPageBuilderService,
        @Inject(APP_BASE_HREF) public appBaseHref: string
    ) {
        super();

        this.primColorPickerField =  AdvancedColorPickerFieldModel.create({
            ...textColorConfig(true),
            label: 'Briefings.fields.image.accent',
            tooltip: 'Briefings.fields.image.accent.tooltip'
        });

        // this.backColorPickerField =  new ColorPickerFieldModel(
        //     null,
        //     'color',
        //     'color',
        //     'Briefings.fields.image.background',
        //     'TextStyle.colorPicker.description',
        //     'TextStyle.colorPicker.dialogHeading',
        //     'agpr-i-font-color',
        //     null,
        //     true
        // );
    }
    ngOnInit(): void {
        this.subscriptions.push(
            this.pageBuilderService.getFocusedResource().subscribe(
                resource => {
                    if (resource?.generalStyles?.accentColor) {
                        this.defaultBriefingColor = resource.generalStyles.accentColor;
                        if (this.value && !this.value.primaryColor) {
                            this.value.primaryColor = this.defaultBriefingColor;
                        }
                    }
                }
            )
        );
    }

    ngOnChanges(simpleChanges: SimpleChanges) {
        if (simpleChanges.hasOwnProperty('value')) {
            if (!this.value) {
                this.value = new BriefingImageEffectsModel();
            }

            if (this.value.transition) {
                this.enableTransition = true;
            }
            if (!this.value.primaryColor && this.defaultBriefingColor) {
                this.value.primaryColor = this.defaultBriefingColor;
            }
        }

        this.imageDisplayElement = this.block.displayElement as BriefingImageDisplayElementModel;
    }

    valueChange(event, property: string) {
        this.value[property] = event;

        this.changes.emit(this.value.clone());
    }

    setFrame(key: BriefingImageFrameEnum) {
        this.value.imageFrame = key;
        this.changes.emit(this.value.clone());
    }

    enableTransitionChanged() {
        if (this.enableTransition) {
            if (!this.value.transition) {
                this.value.transition = 5;
            }
        } else {
            this.value.transition = null;
        }
        this.changes.emit(this.value.clone());
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
}
